import { CoreDomainSearchStore } from '@wix/domains-search-suite';
import { useEffect } from 'react';
import { TLD_PREFILL_QUERY_PARAM } from '../constants';
import { useQueryParams } from './useQueryParams';
export const useTldPrefill = () => {
  const {
    getQueryParam
  } = useQueryParams();
  const tld = getQueryParam(TLD_PREFILL_QUERY_PARAM) ?? undefined;
  const inputRef = CoreDomainSearchStore.useInputRef();
  useEffect(() => {
    const input = inputRef == null ? void 0 : inputRef.input;
    if (!tld || !input) {
      return;
    }
    const value = `.${tld}`;
    input.value = value;
    CoreDomainSearchStore.setQuery(value);
    inputRef.focus();
    inputRef.setSelectionRange(0, 0);
  }, [tld, inputRef]);
  return {
    tld
  };
};
//# sourceMappingURL=useTldPrefill.js.map